/**
 * Input Component - поле ввода с glass эффектом
 */

import React, { forwardRef } from "react";

const Input = forwardRef(
    (
        {
            type = "text",
            placeholder = "",
            value,
            onChange,
            onBlur,
            onFocus,
            disabled = false,
            readOnly = false,
            error = "",
            label = "",
            icon = null,
            className = "",
            fullWidth = false,
            size = "md", // sm | md | lg
            variant = "default", // default | ghost
            ...props
        },
        ref,
    ) => {
        const baseClass = "input";
        const classes = [
            baseClass,
            `${baseClass}--${size}`,
            `${baseClass}--${variant}`,
            error && `${baseClass}--error`,
            icon && `${baseClass}--with-icon`,
            fullWidth && `${baseClass}--full-width`,
            className,
        ]
            .filter(Boolean)
            .join(" ");

        return (
            <div
                className={`${baseClass}-wrapper ${fullWidth ? `${baseClass}-wrapper--full-width` : ""}`}
            >
                {label && (
                    <label className={`${baseClass}-wrapper__label`}>
                        {label}
                    </label>
                )}
                <div className={`${baseClass}-container`}>
                    {icon && (
                        <span className={`${baseClass}__icon`}>{icon}</span>
                    )}
                    <input
                        ref={ref}
                        type={type}
                        className={classes}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        onFocus={onFocus}
                        disabled={disabled}
                        readOnly={readOnly}
                        {...props}
                    />
                </div>
                {error && (
                    <span className={`${baseClass}-wrapper__error`}>
                        {error}
                    </span>
                )}
            </div>
        );
    },
);

Input.displayName = "Input";

export default Input;
